﻿export default class CollectiveAgreementCalculator extends HTMLDivElement {

    constructor() {

        super();

        this.sek = new Intl.NumberFormat('sv-SE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        this.formatKronor = (value) => `${this.sek.format(value)} kronor`;

    }

    get calculateButton() {
        return this.querySelector("[data-collective-agreement-calculator-form-calculate-button]");
    }

    get calculationButton() {
        return this.querySelector("[data-collective-agreement-calculator-form-calculation-button]");
    }

    get ibb() {
        return this.dataset.collectiveAgreementCalculatorIbb;
    }

    get resultElement() {
        return this.querySelector("[data-collective-agreement-calculator-result]");
    }

    get disclaimerElement() {
        return this.querySelector("[data-collective-agreement-calculator-disclaimer]");
    }

    set result(value) {
        this.resultElement.innerHTML = "<p>Du tjänar cirka <span class='resultspan'>" + this.formatKronor(value) + "</span> om året med Finansförbundets kollektivavtal.</p>";
    }

    get salaryElement() {
        return this.querySelector("[data-collective-agreement-calculator-form-salary-input]");
    }

    get salary() {
        return this.salaryElement.value;
    }

    get overtimeElement() {
        return this.querySelector("[data-collective-agreement-calculator-form-overtime-input]");
    }

    get overtime() {
        const value = this.overtimeElement.value;

        if (!value || !value.trim()) {
            return "0";
        }

        const digits = value.match(/\d+/g);

        return digits ? digits.join("") : "0";
    }

    calculateEventHandler(event) {

        event.preventDefault();

        this.disclaimerElement.classList.add("hidden");
        this.resultElement.classList.add("hidden");

        this.result = this.calculate(this.salary, this.overtime, this.ibb, this.method);

        this.resultElement.classList.remove("hidden");
        this.disclaimerElement.classList.remove("hidden");
    }

    calculate(salary, overtime, ibb, method, extra = false) {
        salary = salary.match(/\d+/g).join('');
        overtime = overtime.match(/\d+/g).join('');

        const workingHoursValue = this.calculateWorkingHoursValue(salary);
        const vaccationValue = this.calculateVaccationValue(salary);
        const pensionValue = this.calculatePensionValue(salary, ibb);  
        const overtimeValue = this.calculateOvertimeValue(salary, overtime); 

        return workingHoursValue + vaccationValue + pensionValue + overtimeValue;
    }

    calculateWorkingHoursValue(salary) {
        const workingTimeReductionInHours = 72.0;
        const workingHoursPerMonth = 165.55;
        return salary / workingHoursPerMonth * workingTimeReductionInHours;
    }

    calculateVaccationValue(salary) {
        const extraVaccationDays = 2.0;
        const workDaysPerYear = 250.0;
        const valuePerDay = salary * 12.0 / workDaysPerYear;
        return valuePerDay * extraVaccationDays;
    }

    calculatePensionValue(salary, ibb) {
        const percent1 = 0.065;
        const percent2 = 0.32;
        const threshold = (7.5 * ibb) / 12.0;
        const ceiling = (30.0 * ibb) / 12.0;
        const btp1 = Math.min(salary, threshold) * percent1 + Math.min(ceiling - threshold, Math.max(0, salary - threshold)) * percent2;
        return btp1 * 12.0;
    }

    calculateOvertimeValue(salary, overtime) {
        const workingHoursPerMonth = 165.55;
        const multiplier = 1.5;
        return (salary / workingHoursPerMonth) * overtime * multiplier;
    }

    connectedCallback() {
        var calculator = this;
        this.calculateButton.addEventListener("click", function (event) {
            calculator.calculateEventHandler(event)
        });

        this.calculationButton.addEventListener("click", function (event) {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.display === "block") {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        });
    }

}

customElements.define('collective-agreement-calculator', CollectiveAgreementCalculator, { extends: "div" });